module.exports = __webpack_public_path__ + "media/images/dividend/img-ashley-259159474891ba399f164768108607b6.png";